module.exports = __webpack_public_path__ + "img/1F55D.6a0eb601.svg";